import {
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';
import {
  compareValues,
  SortDirection,
  toggleSortDirection,
} from '../../../lib/utils/sort';
import { ExamService } from '../../../services';
import { Exam } from '../../../types';

@Component({
  selector: 'app-exam-table',
  templateUrl: './exam-table.component.html',
  styleUrls: ['./exam-table.component.scss'],
})
export class ExamTableComponent implements OnInit {
  @HostBinding('class.entity-table-component')
  hostClass = true;

  sortColumn: keyof Exam = 'testname';
  sortDirection: SortDirection = 'asc';

  constructor(public service: ExamService) {}

  ngOnInit(): void {
    // Set defaults from existing state
    this.sortColumn = this.service.listState.filter
      .sort as keyof Exam;
    this.sortDirection =
      this.service.listState.filter.direction;

    // Load initial data
    this.service.loadExamList();
  }

  get items(): Exam[] {
    const sorted = [
      ...this.service.listState.response.items,
    ];
    return this.sortArray(sorted);
  }

  sortBy(column: keyof Exam) {
    const next = toggleSortDirection(
      this.sortColumn,
      column,
      this.sortDirection
    );
    this.sortColumn = next.column;
    this.sortDirection = next.direction;

    this.service.listState.filter.sort = this.sortColumn;
    this.service.listState.filter.direction =
      this.sortDirection;

    this.service.loadExamList();
  }

  private sortArray(array: Exam[]): Exam[] {
    return array.sort((a, b) => {
      const aVal = a[this.sortColumn] ?? '';
      const bVal = b[this.sortColumn] ?? '';
      return compareValues(aVal, bVal, this.sortDirection);
    });
  }
}
